/* eslint-disable max-len */
/* eslint-disable no-plusplus */
/* eslint-disable no-console */
/* eslint-disable import/no-extraneous-dependencies */
/*  eslint-disable no-unused-expressions */
import { Autocomplete, TextField, CircularProgress, Grid, createFilterOptions, IconButton, Radio, RadioGroup, FormControlLabel, FormControl, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import LoadingButton from '@mui/lab/LoadingButton';
import React, { useState, useRef, useEffect } from 'react';
import { removeElements } from 'react-flow-renderer';
import CloseIcon from '@mui/icons-material/Close';
import Modal from 'react-modal';
import '../styles/AnimeList.css';
import Notification from '../shared/notification-modal';
import { defaultModalOptions } from '../shared/constantVariable';
import { getWinflowsFileList } from '../shared/api/url-helper';
import { setProjectInfoOpenFlag } from './userData';

const filter = createFilterOptions({
  matchFrom: 'start',
  stringify: (option) => option.name,
});
export default function AnimeList(props) {
  const navigate = useNavigate();
  const [modalOption, setModalOption] = useState(defaultModalOptions);
  const {
    setModalIsOpen_filehandle,
    elements,
    setElements,
    jsonFileUpload,
    openModelPopUp,
    forceUpdate,
    translateObject
  } = props;
  const [open, setOpen] = React.useState(false); // if dropdown open?
  const [value, setValue] = React.useState({});
  const [selfSharedFlag, setSelfSharedFlag] = React.useState('self');
  const [selfData, setSelfData] = React.useState([]);
  const [sharedData, setSharedData] = React.useState([]);
  const [fileName, setFileName] = React.useState(' ');
  const [buttonLoading, setBtnLoading] = useState(false);
  const [data, setData] = React.useState([]);
  const [selectedFile, setSelectedFile] = useState();
  const [isFilePicked, setIsFilePicked] = useState(false);
  const [disabledLoadingBalance, setDisabledLoadingBalance] = useState(true);
  const freeSoloDialog = useRef();
  const [, setDialogValue] = React.useState({
    name: '',
    slug: '',
    image: '',
  });

  const loading = open && data.length === 0; // is it still loading
  const getUserEmail = sessionStorage.getItem('user_email');
  const getUserType = getUserEmail.split('@')[1] === 'veolia.com' ? 'internal' : 'external';
  React.useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      // const getUserDetails = await cognitoUtils.getCognitoSession();
      // const getUserEmail = getUserDetails.user.email;
      // sessionStorage.getItem('expTime');

      // const getUserEmail = sessionStorage.getItem('user_email');
      // const getUserDetails = sessionStorage.getItem('user_name');

      getWinflowsFileList(getUserEmail, getUserType)

        // const config = {
        //   method: 'get',
        //   // url: `https://4qw7n6f4eg.execute-api.us-east-1.amazonaws.com/dev/getfilelist?param1=${getUserEmail}`,
        //   // url: `https://4qw7n6f4eg.execute-api.us-east-1.amazonaws.com/dev/winflows_getFileList?param1=${getUserEmail}`, // old
        //   url: `https://m99wyqg41j.execute-api.us-east-1.amazonaws.com/v0/winflows_get_file_list?param1=${getUserEmail}&param2=${getUserType}`,
        //   // url: `https://m99wyqg41j.execute-api.us-east-1.amazonaws.com/v0/winflows_get_file_list?param1=${getUserEmail}`,
        // };
        // axios(config)
        .then((response) => {
          response.data = response.data.filter((category) => category.name);
          if (active) {
            setData([...response.data]);
            const resultData = response.data;
            const myfile = [];
            const sharedOtherFile = [];
            resultData.map((data) => {
              data.name = data.name.split('.json')[0];
              if (data.name.indexOf('-sharedFile') >= 0) {
                data.name = data.name.split('-sharedFile')[0];
                sharedOtherFile.push(data);
              } else {
                myfile.push(data);
              }
            });
            setSelfData([...myfile]);
            setSharedData([...sharedOtherFile]);
          }
        })
        .catch(() => {
          openModelPopUp(translateObject('Failed to load win files'), 'Error', 'error');
        });
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  // ############### unmounting state ##############
  useEffect(() => {
    return () => {
      setBtnLoading(false);
      setData([]);
      setDialogValue({});
    };
  }, []);

  const handleCloseModal = () => {
    setModalOption({
      ...defaultModalOptions,
      visible: true,
      title: 'Warning',
      message: translateObject('Do you want to close the page?'),
      yesOrNo: true,
      onNo: () => setModalOption(defaultModalOptions),
      onYes: () => setModalIsOpen_filehandle(false),
    });
  };
  const handleFormSubmit = async (event) => {
    event.preventDefault();
    setBtnLoading(true);
    setProjectInfoOpenFlag(false);
    if (isFilePicked === true && selfSharedFlag === 'upload') {
      jsonFileUpload(selectedFile);
    } else if (value && value.name) {
      elements.forEach(element => {
        setElements((els) => removeElements([element], els));
      });
      if (selfSharedFlag === 'sharedOther') {
        localStorage.setItem('uploadwinfile', JSON.stringify({
          filename: `${value.name}-sharedFile.json`,
          flag: false,
          data: null
        }));
        navigate('/main');
        forceUpdate();
      } else {
        localStorage.setItem('uploadwinfile', JSON.stringify({
          filename: `${value.name}.json`,
          flag: false,
          data: null
        }));
        navigate('/main');
        forceUpdate();
      }
    }
  };
  const handleChange = (event) => {
    setSelfSharedFlag(event.target.value);
    setBtnLoading(false);
    const ele = freeSoloDialog.current;
    if (ele.querySelector('.MuiAutocomplete-clearIndicator')) {
      ele.querySelector('.MuiAutocomplete-clearIndicator').click();
      ele.querySelector('#free-solo-dialog-demo').blur();
    }
  };
  const changeHandler = (event) => {
    setSelectedFile(event);
    setIsFilePicked(true);
    setFileName(event.target.files[0].name || ' ');
  };
  useEffect(() => {
    setDisabledLoadingBalance(true);
    if (
      ((selfSharedFlag === 'self' || selfSharedFlag === 'sharedOther') && Object.keys(value).length > 0) ||
      (isFilePicked === true && selfSharedFlag === 'upload')) {
      setDisabledLoadingBalance(false);
    }
  });
  return (
    <div>
      <Notification
        options={modalOption}
        handleClose={() => setModalOption(defaultModalOptions)}
      />
      <Modal>isOpen</Modal>
      <form onSubmit={handleFormSubmit} style={{ 'position': 'relative' }}>
        <div className="close_FileDialog" style={{ position: 'absolute', right: '0' }} >
          <span onClick={handleCloseModal}>
            <IconButton>
              <CloseIcon />
            </IconButton>
          </span>
        </div>
        <div className='content-open-file' style={{ padding: '20px 40px' }}>
          <FormControl className="sansW4SeLig winfile-self">
            <RadioGroup
              onChange={handleChange}
              value={selfSharedFlag} row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
            >
              <FormControlLabel value="self" control={<Radio />} label={translateObject('My Files')} />
              <FormControlLabel value="sharedOther" control={<Radio />} label={translateObject('Shared By Others')} />
              <FormControlLabel value="upload" control={<Radio />} label={translateObject('Upload File')} />
            </RadioGroup>
          </FormControl>
          {selfSharedFlag && <Autocomplete
            ref={freeSoloDialog}
            id="free-solo-dialog-demo"
            open={open}
            onOpen={() => { setOpen(true); }}
            onClose={() => { setOpen(false); }}
            loading={loading}
            isOptionEqualToValue={(option, value) => option.name === value.name}
            getOptionLabel={(option) => option.name}
            options={selfSharedFlag === 'self' ? selfData : sharedData}
            onChange={(event, newValue) => {
              if (newValue && newValue.name) {
                setValue(newValue);
              } else {
                setValue({});
              }
            }}
            filterOptions={(options, params) => {
              const filtered = filter(options, params);
              const isExisting = options.some(
                (option) => params.inputValue === option.name
              );
              if (params.inputValue !== '' && !isExisting) {
                filtered.push({
                  inputValue: params.inputValue,
                  name: `Add "${params.inputValue}" Category`,
                });
              }
              return filtered;
            }}
            renderOption={(props, option, { inputValue }) => {
              const matches = match(option.name, inputValue);
              const parts = parse(option.name, matches);
              const textFormat = (text) => {
                if (!text) return '';
                if (text.length > 45) {
                  return `${text.slice(0, 45)}...`;
                }
                return text;
              };
              return (
                <li {...props} key={`aa${Math.random().toString(36).slice(2, 7)}`}>
                  <div key={`bb${Math.random().toString(36).slice(2, 7)}`}>
                    {parts.map((part, index) => (
                      <Tooltip title={part.text} key={index}>
                        <span
                          style={{
                            color: part.highlight ? 'red' : 'inherit',
                            fontWeight: part.highlight ? 700 : 400,
                          }}
                        >
                          {textFormat(part.text)}
                        </span>
                      </Tooltip>
                    ))}
                  </div>
                </li>
              );
            }}
            renderInput={(params) => (
              <div>{selfSharedFlag !== 'upload' ? <TextField
                {...params}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
                label={translateObject('Load Winflows Design Simulator file')}
              /> :
                <label>
                  <Grid container spacing={1} style={{}} className='select_container'>
                    <Grid item xs={4} className="rufusBld select_box_1">
                      <svg xmlns="http://www.w3.org/2000/svg" width="33" height="42" viewBox="0 0 33 42">
                        <g id="Group_28629" data-name="Group 28629" transform="translate(0.438)">
                          <path id="Rectangle_13777" data-name="Rectangle 13777" d="M5,0H18A10,10,0,0,1,28,10V31a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0Z" transform="translate(-0.438)" fill="#CCE4FF" />
                          <circle id="Ellipse_254" data-name="Ellipse 254" cx="8.5" cy="8.5" r="8.5" transform="translate(15.562 25)" fill="#0679CC" />
                          <g id="Icon_feather-upload" data-name="Icon feather-upload" transform="translate(20.914 29.914)">
                            <path id="Path_13944" data-name="Path 13944" d="M11.148,22.5V24a.746.746,0,0,1-.739.752H5.239A.746.746,0,0,1,4.5,24V22.5" transform="translate(-4.5 -18.109)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" />
                            <path id="Path_13945" data-name="Path 13945" d="M14.138,6.381,12.319,4.5,10.5,6.381" transform="translate(-8.995 -4.5)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" />
                            <path id="Path_13946" data-name="Path 13946" d="M18,4.5V9.015" transform="translate(-14.676 -4.5)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" />
                          </g>
                        </g>
                      </svg>
                    </Grid>
                    <Grid item xs={8} className="rufusBld select_box_2">
                      <p style={{ 'fontSize': '14px', color: '#0679CC' }}>{translateObject('Select file to upload')}</p>
                      <p style={{ 'fontSize': '10px', 'color': '#55555A' }}>{fileName}</p>
                    </Grid>
                  </Grid>
                  <input type="file" id="file-input" accept=".win" onChange={changeHandler} style={{ 'display': 'none' }} />
                </label>
              }
              </div>
            )}
          />}
          <LoadingButton
            loading={buttonLoading}
            size="small"
            variant="contained"
            id="loadButton"
            className="LoadButton Primary_Default_Button"
            type="submit"
            disabled={disabledLoadingBalance}
          >
            <span className="sansW4SeLig">{translateObject('Load')}</span>
          </LoadingButton>
        </div>
      </form>
    </div>
  );
}
